<template>
  <div class="mx-auto">
    <div class="d-flex cards">
      <div>
        <v-card>
          <v-card-title>Monthly Cost</v-card-title>
          <v-card-text>
            <div>
              <span class="rupee">&#8377;</span>
              <strong>{{ $toFixed(monthlyCost) }}</strong>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <v-card>
          <v-card-title>Wallet Balance</v-card-title>
          <v-card-text>
            <div>
              <span class="rupee">&#8377;</span>
              <strong>{{ $toFixed(walletBalance, 2) }}</strong>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <v-card>
          <v-card-title>Base Pack {{ basePackExpired ? 'Expired' : 'Expires' }} On</v-card-title>
          <v-card-text>
            <div>
              <strong>{{ basePack ? basePack.end_DATE : 'No Base Pack' }}</strong>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-card-text class="text-center">Keep your Account Top Up to enjoy Uninterrupted Service</v-card-text>
    <v-card-actions>
      <div class="mx-auto">
        <Button
        @click="goTo('/topup')"
          color="primary"
          cssClass="mb-8 topup"
          label="Top Up"
          rounded
        />
      </div>
    </v-card-actions>
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
import { mapState, mapGetters, } from 'vuex';

export default {
  components: {
    Button
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('auth', ['walletBalance']),
    ...mapGetters('auth', ['monthlyCost', 'basePack', 'isDP']),
    basePackExpired() {
      return this.basePack && this.basePack.expired === true;
    }
  },
  methods:{
    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    }
  }
};
</script>
<style scoped>
.cards {
  padding-top: 50px;
  padding-bottom: 40px;
  justify-content: space-evenly;
}
.cards > div > div {
  height: 110px;
  min-width: 250px;
  border-radius: 10px !important;
}
.rupee {
  margin-left: 5px;
  margin-right: 5px;
}
.topup {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}
</style>